import React from "react";
import { useState } from "react";
import contact from "../pages/contact";
import logo from "..//assets/logo.png";
import { CiUser } from "react-icons/ci";
import icon from "..//assets/icon.png";
import icon1 from "..//assets/icon1.png";
import icon2 from "..//assets/icon2.png";
import icon3 from "..//assets/icon3.png";
import face from "..//assets/face.png";
import twit from "..//assets/video.png";
import insta from "..//assets/insta.png";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";
import adultProduct1 from "../assets/Adult_Diaper/bestie2.1.jpg";
import adultProduct2 from "../assets/Adult_Diaper/bestie2.2.jpg";
import adultProduct3 from "../assets/Adult_Diaper/bestie2.3.jpg";
import adultProduct4 from "../assets/Adult_Diaper/bestiee2.0.jpg";
import adultProduct5 from "../assets/Adult_Diaper/bestiee7.jpg";
import padProduct1 from "../assets/Sanitary_Pad/pad1.jpeg";
import padProduct2 from "../assets/Sanitary_Pad/pad2.jpeg";
import padProduct3 from "../assets/Sanitary_Pad/pad3.jpeg";
import padProduct4 from "../assets/Sanitary_Pad/pad4.jpeg";
import padProduct5 from "../assets/Sanitary_Pad/pad5.jpeg";
import padProduct6 from "../assets/Sanitary_Pad/pad6.jpeg";
import wetWipe1 from "../assets/Wet_wipes/post1.jpg";
import wetWipe2 from "../assets/Wet_wipes/post2.jpg";
import wetWipe3 from "../assets/Wet_wipes/post3.jpg";
import wetWipe4 from "../assets/Wet_wipes/post4.jpg";
import wetWipe5 from "../assets/Wet_wipes/post5.jpg";
import babyDiaper1 from "../assets/baby-diaper/babycover1.jpg";
import babyDiaper2 from "../assets/baby-diaper/babycover2.jpg";
import babyDiaper3 from "../assets/baby-diaper/babycover3.jpg";
import babyDiaper4 from "../assets/baby-diaper/babycover4.jpg";
import babyDiaper5 from "../assets/baby-diaper/babycover5.jpg";
import product from "..//assets/product1.png";
import product1 from "..//assets/product2.png";
import product2 from "..//assets/product3.png";
import Slider from "react-slick";
import product3 from "..//assets/product4.png";
import product4 from "..//assets/product5.png";
import product5 from "..//assets/product6.png";
import product6 from "..//assets/product7.png";
import product7 from "..//assets/product8.png";
import ProductDetails from "./productDetail";
import returnIcon from "../assets/icons/arrow-right-left.svg";
import shippingIcon from "../assets/icons/la--shipping-fast.svg";

// import bannerImage from './assets/banner.jpg';  // Logo image path
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function Product() {
    return (
        <>
            <Header />
            <Product1 />
            <FAQSection />
            <Footer />
            {/* <AnimatedBoxes />  */}
        </>
    );
}

function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                display: "block",
                background: "grey",
                borderRadius: "50%",
                marginLeft: "20px",
                zIndex: 1000,
            }}
            onClick={onClick}
        />
    );
}
function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className}`}
            style={{
                ...style,
                display: "block",
                background: "grey",
                borderRadius: "50%",
                marginRight: "20px",
            }}
            onClick={onClick}
        />
    );
}
function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative hidden">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser className="hidden" />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function Product1() {
    const products = [
        {
            id: 1,
            name: "Adult Diaper ",
            //   color: "Red",
            price: "MRP: ₹550.00",
            imageSrc: [
                {
                    imgId: 1,
                    src: adultProduct4 ,
                },
                { imgId: 2, src: adultProduct2 },
                { imgId: 3, src: adultProduct3 },
                { imgId: 4, src: adultProduct1},
                { imgId: 4, src: adultProduct5 },
            ],

            imageAlt: "Product  description",
            className: "font-sans font-semibold",
            href: "/product1",
        },
        {
            id: 2,
            name: "Sanitary Pads",
            //   color: "Blue",
            price: "MRP: ₹250.00",
            imageSrc: [
                {
                    imgId: 1,
                    src: padProduct4,
                },
                { imgId: 2, src: padProduct2 },
                { imgId: 3, src: padProduct3 },
                { imgId: 4, src: padProduct1 },
                { imgId: 5, src: padProduct5 },
                { imgId: 6, src: padProduct6 },
            ],
            imageAlt: "Product 2 description",
            href: "/product3",
        },

        {
            id: 3,
            name: "Wet Wipes",

            price: "MRP: ₹120.00",
            imageSrc: [
                { imgId: 1, src: wetWipe5 },
                {
                    imgId: 2,
                    src: wetWipe1,
                },
                { imgId: 3, src: wetWipe2 },
                { imgId: 4, src: wetWipe3 },
                { imgId: 5, src: wetWipe4 },
                
            ],
            imageAlt: "Product 3 description",
            href: "/product2",
        },
        {
            id: 4,
            name: "Baby Diaper ",
            imageSrc: [
                { imgId: 1, src: babyDiaper5 },
                {
                    imgId: 2,
                    src: babyDiaper1,
                },
                { imgId: 3, src: babyDiaper2 },
                { imgId: 4, src: babyDiaper3 },
                { imgId: 5, src: babyDiaper4 },
                
            ],
            price: "MRP: ₹1190.00",
            imageAlt: "Product 4 description",
            href: "/product4",
        },
        // {
        //   id: 5,
        //   name: "Microfabric Fabric Round Neck Half Sleeve T-Shirt with Brea... ",

        //   price: "₹799.00",
        //   imageSrc: product4,
        //   imageAlt: "Product 5 description",
        //   href: "/product2",
        // },
        // {
        //   id: 6,
        //   name: "Microfabric Fabric Round Neck Full Sleeve T-Shirt with Brea... ",

        //   price: "₹899.00",
        //   imageSrc: product5,
        //   imageAlt: "Product 6 description",
        //   href: "/product6"
        // },
        // {
        //   id: 7,
        //   name: "Microfabric Fabric Round Neck Half Sleeve T-Shirt with Brea... ",
        //   // color: "Blue",
        //   price: "₹680.00",
        //   imageSrc: product6,
        //   imageAlt: "Product 7 description",
        //   href: "/product7"
        // },
        // {
        //   id: 8,
        //   name: "Microfabric Fabric Round Neck Half Sleeve T-Shirt with Brea... ",
        //   // color: "Blue",
        //   price: "₹350.00",
        //   imageSrc: product7,
        //   imageAlt: "Product 8 description",
        //   href: "/product8"
        // },
        // Add more products as needed
    ];
    return (
        <div className="mt-10 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <Link
                        to="/"
                        className="font-sans text-lg font-medium hover:text-gray-700"
                    >
                        Home
                    </Link>
                    <span className="text-gray-400">›</span>
                    <Link
                        to="/products"
                        className="font-sans text-lg font-medium hover:text-black"
                    >
                        Products
                    </Link>
                </div>

                <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-6 xl:gap-x-8">
                        {products.map((product) => (
                            <div
                                key={product.id}
                                className="relative overflow-hidden bg-white border border-gray-200 shadow-lg group rounded-xl"
                            >
                                <div className="w-full px-2 py-2 bg-white aspect-w-1 aspect-h-1 rounded-t-xl lg:aspect-none">
                                    <Slider
                                        slidesToShow={1}
                                        slidesPerRow={1}
                                        slidesToScroll={1}
                                        autoplay
                                        prevArrow={<PrevArrow />}
                                        nextArrow={<NextArrow />}
                                    >
                                        {product.imageSrc.map((img) => (
                                            <img
                                                src={img.src}
                                                key={img.imgId}
                                                alt={product.name}
                                                className="relative z-0 m-auto transition-all duration-300 rounded-lg lg:w-13/12 h-64 hover:scale-110"
                                            />
                                        ))}
                                    </Slider>
                                </div>
                                <div className="p-4 space-y-2 ">
                                    <h3 className="text-sm text-gray-700">
                                        {product.name}
                                    </h3>

                                    {!(product.id === 3) && (
                                        <div className="flex gap-4">
                                            <h4 className="bg-[#a7a7a7] flex justify-center items-center w-[24px] rounded-md text-[#f2f2f2] text-[14px]">
                                                S
                                            </h4>
                                            <h4 className="bg-[#a7a7a7] flex justify-center items-center w-[24px] rounded-md text-[#f2f2f2] text-[14px]">
                                                M
                                            </h4>
                                            <h4 className="bg-[#a7a7a7] flex justify-center items-center w-[24px] rounded-md text-[#f2f2f2] text-[14px]">
                                                L
                                            </h4>
                                            <h4 className="bg-[#a7a7a7] flex justify-center items-center w-[24px] rounded-md text-[#f2f2f2] text-[14px]">
                                                XL
                                            </h4>
                                        </div>
                                    )}
                                    {product.id === 3 && (
                                        <div className="pt-[20px] "></div>
                                    )}
                                    <div className="flex items-end justify-between">
                                        <p className="text-sm font-medium text-gray-900">
                                            {product.price}
                                        </p>
                                        
                                        
                                        <Link to={product.href}>
                                            <button className="py-1 px-2 bg-[#52B3A4] text-white text-xs rounded-md hover:bg-[#52B3A4]">
                                                View Product
                                            </button>
                                        </Link>
                                        
                                    </div>
                                    <Link to="https://wa.me/8660110969">
                                            <button className="py-1 px-1 w-full mt-3 bg-[#52B3A4] text-white text-xs rounded-md hover:bg-[#52B3A4]">
                                                Click here for offers
                                            </button>
                                        </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const faqs = [
        {
            question: "Are your Diapers Safe For Sensitive Skin?",
            answer: "Yes! Our baby diapers are made with hypoallergenic, breathable, and ultra-soft materials to prevent rashes and irritation.",
        },
        {
            question: "Do Your Diapers Have Wetness Indicators?",
            answer: "Yes, our diapers come with a wetness indicator that changes color when it’s time for a diaper change.",
        },
        {
            question: " Are Your Baby Wipes Alcohol-Free?",
            answer: "Yes! Our baby wipes are alcohol-free, fragrance-free, and enriched with natural ingredients like aloe vera and vitamin E to protect delicate skin.",
        },
        {
            question: " How Absorbent Are Your Adult Diapers?",
            answer: "Our adult diapers are designed with high-absorbency technology, offering long-lasting dryness and leak protection for day and night use.",
        },
        {
            question: "  Are Your Sanitary Pads Chemical-Free?",
            answer: "Our sanitary pads are free from harsh chemicals and made with skin-friendly materials for maximum comfort and protection.",
        },
        {
            question: " How Long Does Delivery Take?",
            answer: "Delivery times vary depending on your location. Typically, orders are delivered within 3-7 business days.",
        },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="w-full py-16 bg-gray-50">
            {" "}
            {/* Full section wrapper with padding */}
            <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-8">
                {" "}
                {/* Container for equal left-right space */}
                <h2 className="font-sans text-3xl font-semibold tracking-tight text-center text-gray-900">
                    Frequently Asked Questions
                </h2>
                <br></br>
                {/* FAQ List */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="pb-4 border-b-2 border-gray-200 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="font-sans text-lg font-semibold text-gray-700">
                                    {faq.question}
                                </h3>
                                <svg
                                    className={`w-6 h-6 transition-transform transform ${
                                        activeIndex === index
                                            ? "rotate-180"
                                            : ""
                                    }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                            {activeIndex === index && (
                                <p className="mt-2 text-gray-600">
                                    {faq.answer}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-3">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={shippingIcon}
                        alt="Safe Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Shipping All Over India
                    </h3>
                </div>

                {/* Column 2 */}
                {/* <div className="flex flex-col items-center">
          <img src={icon1} alt="Secure Payment" className="w-12 h-12" />
          <br></br>
          <h3 className="font-sans font-bold">Secure Payment</h3>
          <p className="font-sans font-normal ">Guaranteed safe checkout</p>
        </div> */}

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Dedicated Customer Support
                    </h3>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={returnIcon}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Safe and quick delivery
                    </h3>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://www.facebook.com/bestie.care.hygiene/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.youtube.com/@BestieHygiene"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="youtube" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.instagram.com/bestie.hygienecare/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D# "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Bestie care. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default Product;
